import { render } from "./ContactPageA.vue?vue&type=template&id=68b509c1&scoped=true"
import script from "./ContactPageA.vue?vue&type=script&lang=js"
export * from "./ContactPageA.vue?vue&type=script&lang=js"

import "./ContactPageA.vue?vue&type=style&index=0&id=68b509c1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b509c1"]])

export default __exports__